import axios from 'axios';
import { CONFIG } from '../constants/config';

// API Service Class following Single Responsibility Principle
class ApiService {
  // Submissions API
  static async getSubmissions(page = 1, search = '') {
    const response = await axios.get(CONFIG.API_ENDPOINTS.SUBMISSIONS, {
      params: {
        page,
        per_page: CONFIG.SUBMISSIONS_PER_PAGE,
        search: search.trim()
      }
    });
    return response.data;
  }

  static async createSubmission(submissionData) {
    if (CONFIG.TESTING_MODE.ENABLED && CONFIG.TESTING_MODE.CREATE_MOCK_PAYMENTS) {
      // In testing mode, include the initial payment amount
      const response = await axios.post(CONFIG.API_ENDPOINTS.SUBMISSIONS, {
        ...submissionData,
        initial_amount: submissionData.initial_amount || CONFIG.DEFAULT_INITIAL_PAYMENT
      });
      return response.data;
    }
    
    const response = await axios.post(CONFIG.API_ENDPOINTS.SUBMISSIONS, submissionData);
    return response.data;
  }

  // Payment API
  static async createCheckoutSession(submissionId, amount, submissionData = null, paymentRegion = 'us') {
    if (CONFIG.TESTING_MODE.ENABLED && CONFIG.TESTING_MODE.BYPASS_STRIPE) {
      // In testing mode, simulate success without actual payment
      return { session_id: 'test_session_id', testing: true };
    }

    const response = await axios.post(CONFIG.API_ENDPOINTS.CREATE_CHECKOUT, {
      submission_id: submissionId,
      amount: amount,
      submission_data: submissionData,
      payment_region: paymentRegion
    });
    return response.data;
  }

  // Payment API (testing mode)
  static async createPayment(submissionId, amount) {
    if (!CONFIG.TESTING_MODE.ENABLED) {
      throw new Error('Payments only available in testing mode');
    }

    const response = await axios.post('/api/payments', {
      submission_id: submissionId,
      amount: amount
    });
    return response.data;
  }

  // File Upload API
  static async uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(CONFIG.API_ENDPOINTS.UPLOAD_IMAGE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
}

// Payment Service (separate responsibility)
class PaymentService {
  static async processStripePayment(sessionId) {
    if (CONFIG.TESTING_MODE.ENABLED && CONFIG.TESTING_MODE.BYPASS_STRIPE) {
      // Skip Stripe processing in testing mode
      return { success: true, testing: true };
    }

    if (!window.Stripe) {
      throw new Error('Payment system is loading. Please try again in a moment.');
    }

    const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
    return await stripe.redirectToCheckout({ sessionId });
  }
}

export { ApiService, PaymentService }; 